import {Empty, Space, Spin, Tabs} from 'antd';

import {PageCard} from '../../../../../layout/page-card/page-card';
import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {isAiMonitoringRunTerminal} from '../../../../../service/ai-brand-monitoring/ai-brand-monitoring-const';
import {
    AiMonitoringRunType,
    AiMonitoringScorePointType,
} from '../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';
import {AiMonitoringRunStatusTag} from '../run-status-tag';

import {BrandAnalysisTab} from './brand-analysis/brand-analysis-tab';
import {PromptMentionsTab} from './prompt-mentions/prompt-mentions-tab';
import * as styles from './run-section.scss';

type PropsType = {
    brandId: number;
    run: AiMonitoringRunType | undefined;
    currentRunId: string | null;
    series: Array<AiMonitoringScorePointType>;
    competitorIds: Array<number>;
};

export function RunSection(props: PropsType): JSX.Element {
    const {brandId, run, currentRunId, series, competitorIds} = props;
    const {getLocalizedString} = useLocale();

    if (!run) {
        return (
            <PageCard>
                <Empty description={getLocalizedString('AI_BRAND_MONITORING__DASHBOARD__NO_RUNS')} />
            </PageCard>
        );
    }

    // A run that has not reached a terminal status yet — its results are still being filled by
    // airequester, so show progress instead of empty tabs.
    if (!isAiMonitoringRunTerminal(run.status)) {
        return (
            <PageCard>
                <Space align="center" className={styles.run_section__progress} direction="vertical" size="middle">
                    <Spin size="large" />
                    <AiMonitoringRunStatusTag status={run.status} />
                    <div className={styles.run_section__progress_note}>
                        <Locale stringKey="AI_BRAND_MONITORING__DASHBOARD__RUN_IN_PROGRESS" />
                    </div>
                </Space>
            </PageCard>
        );
    }

    return (
        <Tabs
            items={[
                {
                    key: 'brand-analysis',
                    label: getLocalizedString('AI_BRAND_MONITORING__TABS__BRAND_ANALYSIS'),
                    children: (
                        <BrandAnalysisTab brandId={brandId} currentRunId={currentRunId} run={run} series={series} />
                    ),
                },
                {
                    key: 'prompt-mentions',
                    label: getLocalizedString('AI_BRAND_MONITORING__TABS__PROMPT_MENTIONS'),
                    children: (
                        <PromptMentionsTab
                            brandId={brandId}
                            competitorIds={competitorIds}
                            currentRunId={currentRunId}
                            run={run}
                            series={series}
                        />
                    ),
                },
            ]}
        />
    );
}
